import React from 'react';
import { SimpleForm, Create, SaveButton, Toolbar } from 'react-admin';
import { EventFields } from './components/EventFields';

export const EventCreate = () => {
  return (
    <Create title={'New Event'} redirect="list">
      <SimpleForm
        toolbar={
          <Toolbar>
            <SaveButton />
          </Toolbar>
        }
      >
        <EventFields />
      </SimpleForm>
    </Create>
  );
};
